// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_d1-b";
export var colorBlue = "_d1-8";
export var colorDot = "_d1-0";
export var colorDotLarge = "_d1-2";
export var colorDotSmall = "_d1-1";
export var colorGreen = "_d1-7";
export var colorGrey = "_d1-3";
export var colorOrange = "_d1-5";
export var colorPink = "_d1-a";
export var colorPurple = "_d1-9";
export var colorRed = "_d1-4";
export var colorYellow = "_d1-6";